@if (ready && jobLinkerToEdit) {
  <div class="grid field col-12">
    <!-- Consumer -->
    <div class="grid field col-12">
      <div class="col-12 md:col-2">
        <label>Operator</label>
      </div>
      <div class="col-12 md:col-10">
        <p-select [options]="companySelectItems" placeholder="Select Company" [(ngModel)]="jobLinkerToEdit.consumerId" [disabled]="true"></p-select>
        @if (modelInvalid && !jobLinkerToEdit.consumerId) {
          <div class="grid field col-12">
            <label style="color:red; font-weight:bold;">Operator is required!</label>
          </div>
        }
      </div>
    </div>
    <!-- WellName -->
    <div class="grid field col-12">
      <div class="col-12 md:col-2">
        <label>Well Name</label>
      </div>
      <div class="col-12 md:col-10">
        <input type="text" pInputText placeholder="Enter Well Name" [(ngModel)]="jobLinkerToEdit.wellName" />
        @if (modelInvalid && !(jobLinkerToEdit.wellName || jobLinkerToEdit.apiNumber)) {
          <div class="grid field col-12">
            <label style="color:red; font-weight:bold;">Well Name or Api Number is required!</label>
          </div>
        }
      </div>
    </div>
    <!-- Api Number -->
    <div class="grid field col-12">
      <div class="col-12 md:col-2">
        <label>Api Number</label>
      </div>
      <div class="col-12 md:col-10">
        <p-inputMask mask="99-999-99999" [(ngModel)]="jobLinkerToEdit.apiNumber" placeholder="99-999-99999">
        </p-inputMask>
        @if (modelInvalid && !(jobLinkerToEdit.wellName || jobLinkerToEdit.apiNumber)) {
          <div class="grid field col-12">
            <label style="color:red; font-weight:bold;">Well Name or Api Number is required!</label>
          </div>
        }
      </div>
    </div>
    <!-- Job Types -->
    <div class="grid field col-12">
      <div class="col-12 md:col-2">
        <label>Job Type</label>
      </div>
      <div class="col-12 md:col-10">
        <p-select [options]="jobTypes" placeholder="Select Type" [(ngModel)]="jobLinkerToEdit.jobType" [disabled]="true"></p-select>
        @if (modelInvalid && !jobLinkerToEdit.jobType) {
          <div class="grid field col-12">
            <label style="color:red; font-weight:bold;">Type is required!</label>
          </div>
        }
      </div>
    </div>
    <!-- VendorJobs -->
    <div class="grid field col-12">
      <div class="col-12 md:col-2">
        <label>Service Provider Jobs</label>
      </div>
      <div class="col-12 md:col-10">
        <p-multiSelect [options]="vendorJobSelectItems" placeholder="Select Jobs" [(ngModel)]="jobLinkerToEdit.vendorJobIds" [disabled]="true"></p-multiSelect>
        @if (modelInvalid && !jobLinkerToEdit.vendorJobIds) {
          <div class="grid field col-12">
            <label style="color:red; font-weight:bold;">At least one Job is required!</label>
          </div>
        }
      </div>
    </div>
    <!-- Consumer Job -->
    <div class="grid field col-12">
      <div class="col-12 md:col-2">
        <label>Operator Job (If exists yet)</label>
      </div>
      <div class="col-12 md:col-10">
        <p-select [options]="consumerJobSelectItems" placeholder="Select ConsumerJob" [(ngModel)]="jobLinkerToEdit.consumerJobId" (onChange)="consumerJobSelected($event)" [disabled]="true"></p-select>
      </div>
    </div>
    <!-- Start Time -->
    <div class="grid field col-12">
      <div class="col-12 md:col-2">
        <label>Opertor Job Start</label>
      </div>
      <div class="col-12 md:col-10" pTooltip="Start time is auto set if an existing Consumer Job is selected">
        <p-date-picker
          [(ngModel)]="calendarStartTime"
          [showIcon]="true"
          [showTime]="true"
          hourFormat="24"
          yearRange="2018:2038">
        </p-date-picker>
        @if (modelInvalid && !calendarStartTime) {
          <div class="grid field col-12">
            <label style="color:red; font-weight:bold;">Start Time is required!</label>
          </div>
        }
      </div>
    </div>
    <!-- Action Buttons -->
    <div class="grid field col-12">
      @if (isNew) {
        <button pButton
          class="col-12 md:col-3 ui-button-primary action-button"
          (click)="saveJobLinker()" >
          Create
        </button>
      }
      @if (!isNew) {
        <button pButton
          class="col-12 md:col-3 ui-button-primary action-button"
          (click)="saveJobLinker()">
          Update
        </button>
      }
      <button pButton
        class="col-12 md:col-3 p-button-secondary action-button"
        (click)="cancel()">
        Cancel
      </button>
    </div>
  </div>
}
